import { EyeOutlined } from '@ant-design/icons'
import { Tabs } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'

import { AppHeader, ColumnLayout } from '@/components'
import { TrendingContainer } from '@/modules/discover/trending/trending.container'
import { LikedUserRank } from '@/modules/discover/trending/user-ranking.component'
import { routes } from '@/routes'

import { DiscoverAllGroups } from './all-groups/all-groups'
import s from './discover.module.less'

export const DiscoverContainer = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const title = (
    <span className={s.title}>
      <span>{t('discover.title')}</span>
    </span>
  )
  const header = () => (
    <AppHeader title={title} titleString={t('discover.title')} avatar={<EyeOutlined style={{ fontSize: 28 }} />}>
      <Tabs size={'large'} animated={false} activeKey={history.location.pathname} onChange={(tab) => history.push(tab)}>
        <Tabs.TabPane tab={t('groups.trending')} key={routes.discover.posts()} />
        <Tabs.TabPane tab={t('groups.basics.title')} key={routes.discover.groups()} />
      </Tabs>
    </AppHeader>
  )

  return (
    <Switch>
      <Route
        path={routes.discover.posts()}
        render={() => <ColumnLayout header={header()} middle={<TrendingContainer />} right={<LikedUserRank />} />}
      />
      <Route
        path={routes.discover.groups()}
        render={() => <ColumnLayout header={header()} middle={<DiscoverAllGroups type='all' />} />}
      />
      <Redirect to={routes.discover.posts()} />
    </Switch>
  )
}
